import React from "react";

const Close: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.46928 18.4701C4.17639 18.763 4.17664 19.2377 4.46983 19.5303C4.76302 19.8229 5.23814 19.8226 5.53103 19.5297L11.9999 13.0607L18.4683 19.5291C18.7612 19.822 19.2367 19.8226 19.5303 19.5304C19.8239 19.2382 19.8245 18.7639 19.5316 18.471L13.0606 12L19.5307 5.52989C19.8236 5.237 19.8233 4.76237 19.5301 4.46977C19.2369 4.17718 18.7618 4.17742 18.4689 4.47032L11.9999 10.9394L5.53157 4.47102C5.23867 4.17813 4.76322 4.17755 4.46961 4.46972C4.176 4.7619 4.17542 5.23619 4.46831 5.52908L10.9393 12.0001L4.46928 18.4701Z"
        fill="white"
      />
    </svg>
  );
};

export default Close;
